export enum OverallState {
  REQUESTED = "REQUESTED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  COMPLETED_DESKTOP = "COMPLETED_DESKTOP",
  COMPLETED_MOBILE = "COMPLETED_MOBILE",
  ERRORED = "ERRORED",
}

export enum MontageProgressState {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  ERROR = "ERROR",
}

export const TERMINAL_STATES: ReadonlySet<OverallState> = new Set([
  OverallState.COMPLETED,
  OverallState.ERRORED,
]);

export const HAPPY_PATH_EVENTS = [
  "REQUESTED",
  "CREATING",
  "SUBMITTED",
  "QUEUED",
  "CAPTURING",
  "COMPLETED",
] as const;

export type HappyPathEvent = (typeof HAPPY_PATH_EVENTS)[number];

export type ErrorCode =
  | "ERR_VALIDATION"
  | "ERR_CREATION"
  | "ERR_CAPTURE"
  | "ERR_TIMEOUT";

export interface TimelineEntry {
  event: string;
  at: string;
  isMobile?: boolean;
  clipLink?: string;
  errorCode?: string;
  errorMessage?: string;
}

export interface RenderStatus {
  currentState: string;
  firstEventAt?: string;
  lastEventAt?: string;
  completedAt?: string;
  estimatedCompletionAt?: string;
  clipLink?: string;
  errorCode?: string;
  errorMessage?: string;
}

export interface TimelineClip {
  id: string;
  url?: string;
  thumbnailUrl?: string;
  title?: string;
}

export interface ClipStatusTimeline {
  trackId: string;
  clipId?: string;
  montageId?: string;
  contentType?: string;
  game?: number;
  queueName?: string;
  firstEventAt?: string;
  lastEventAt?: string;
  overallState: OverallState;
  desktop?: RenderStatus;
  mobile?: RenderStatus;
  events: TimelineEntry[];
  clip?: TimelineClip;
}

export interface MontageProgress {
  montageId: string;
  total: number;
  completed: number;
  inFlight: number;
  errored: number;
  state: MontageProgressState;
  clips: ClipStatusTimeline[];
}

export interface ClipTimelineQueryData {
  clipTimeline: ClipStatusTimeline | null;
}

export interface ClipTimelineQueryVars {
  trackId: string;
}

export interface MyInTransitClipsQueryData {
  myInTransitClips: ClipStatusTimeline[];
}

export interface MyInTransitClipsQueryVars {
  limit?: number;
}

export interface MontageProgressQueryData {
  montageProgress: MontageProgress | null;
}

export interface MontageProgressQueryVars {
  montageId: string;
}
